/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PositionX } from './PositionX';
import {
    PositionXFromJSON,
    PositionXFromJSONTyped,
    PositionXToJSON,
} from './PositionX';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * Description of a ship in a ship list. Contains static and dynamic information.
 * @export
 * @interface ShipListItem
 */
export interface ShipListItem {
    /**
     * 
     * @type {Ship}
     * @memberof ShipListItem
     */
    ship?: Ship;
    /**
     * 
     * @type {PositionX}
     * @memberof ShipListItem
     */
    position?: PositionX;
}

/**
 * Check if a given object implements the ShipListItem interface.
 */
export function instanceOfShipListItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipListItemFromJSON(json: any): ShipListItem {
    return ShipListItemFromJSONTyped(json, false);
}

export function ShipListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
        'position': !exists(json, 'position') ? undefined : PositionXFromJSON(json['position']),
    };
}

export function ShipListItemToJSON(value?: ShipListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ship': ShipToJSON(value.ship),
        'position': PositionXToJSON(value.position),
    };
}

